import React, { useState, useEffect } from 'react'
import { Form, Select } from 'antd'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import { ServiceProvider } from '../../types'
import { serviceProviderService } from '../../services'

interface ServiceProviderSelectProps {
	form: WrappedFormUtils
}

const ServiceProviderSelect = ({ form }: ServiceProviderSelectProps) => {
	const [value, setValue] = useState<string>('')
	const [serviceProviders, setServiceProviders] = useState<ServiceProvider[]>([])

	useEffect(() => {
		const initServiceProviders = async (): Promise<void> => {
			const { data } = await serviceProviderService.getAll()
			setServiceProviders(data)
		}

		initServiceProviders()
	}, [])

	return (
		<Form.Item label='Service provider'>
			{form.getFieldDecorator('service_provider_id', {
				rules: [
					{
						required: true,
						message: 'Service provider is required'
					}
				]
			})(
				<Select placeholder='Select a service provider' showSearch onSearch={setValue} filterOption={false}>
					{serviceProviders
						.filter(serviceProvider => serviceProvider.name.toLowerCase().includes(value.toLowerCase()))
						.map(serviceProvider => (
							<Select.Option value={serviceProvider.id} key={serviceProvider.id}>
								{serviceProvider.name}
							</Select.Option>
						))}
				</Select>
			)}
		</Form.Item>
	)
}

export default ServiceProviderSelect
